import React from 'react';
import usePageTitle from '../hooks/usePageTitle';
import Dashboard from './dashboard/Dashboard';

/* The Aurora dashboard (owner's pick, 2026-08-23). Data: hooks/useDashboardData.js. */
export default function DashboardPage() {
  usePageTitle('Dashboard');
  return <Dashboard />;
}
